const STRINGS = {
	success: gettext("Success"),
	error: gettext("Error"),
	important: gettext("Important"),
	saveBtn: gettext("Save"),
	cancel: gettext("Cancel"),
	cancelBtn: gettext("Cancel"),
	ok: gettext("Ok"),
	credentialsTableHeader: gettext("Credentials"),
	name: gettext("Name"),
	password: gettext("Password"),
	currentPassword: gettext("Current Password"),
	newPassword: gettext("New Password"),
	email: gettext("Email"),
	preferredLanguage: gettext("Preferred Language"),
	language: gettext("Language"),
	languageNote: gettext(
		"Note: Only sites with this language enabled will use your preferred language."
	),
	timezone: gettext("Timezone"),
	disconnectBtn: gettext("Disconnect"),
	change: gettext("Change"),
	clear: gettext("Clear"),
	unsavedChanges: gettext("Unsaved changes"),
	firstName: gettext("First Name"),
	lastName: gettext("Last Name"),
	googleSSO: gettext("Google Social Sign On"),
	pleaseSelect: gettext("Please select..."),
	searchPlaceholder: gettext("Search your site..."),
	newPasswordPlaceholder: gettext("New Password"),
	returnToOriginalRole: gettext("Return to your account"),
	labels: {
		languageSelector: gettext("Language Selector"),
		search: gettext("Search"),
		searchIcon: gettext("Search Icon"),
		siteDashboard: gettext("Site Dashboard"),
		financialManagement: gettext("Financial Management"),
		reports: gettext("Reports"),
		users: gettext("Users"),
		activity: gettext("Activity"),
		settings: gettext("Settings"),
		help: gettext("Help"),
		userMenu: gettext("User Menu"),
		searchResultItem: gettext("Search Result Item"),
		chevronDown: gettext("Expand menu"),
		showChangeFields: gettext("Change value"),
		displayText: gettext("Display text"),
		fieldError: gettext("Field error"),
		hidePassword: gettext("Hide password"),
		showPassword: gettext("Show password"),
		clearChanges: gettext("Clear changes"),
		roleChoices: gettext("Role choices"),
		assumedRoleControls: gettext("Assumed role controls"),
	},
	toast: {
		success: gettext("Success"),
		error: gettext("Error"),
	},
	fieldErrors: {
		email: gettext("Please enter a valid email address"),
		text: gettext("Field is required"),
		currentPassword: gettext("Please enter your current password"),
		newPassword: gettext(
			"Passwords must be at least 8 characters long, contain at least one number and special character, and have both upper and lower case letters"
		),
	},
	navMenu: {
		admin: {
			general: gettext("General"),
			pages: gettext("Pages"),
			reusableApplicantTasks: gettext("Reusable Applicant Tasks"),
			files: gettext("Files"),
			eligibility: gettext("Eligibility"),
			customFields: gettext("Custom Fields"),
			registration: gettext("Registration"),
			email: gettext("Email"),
			administrators: gettext("Administrators"),
			integrations: gettext("Integrations"),
			translations: gettext("Translations"),
			superuser: gettext("Superuser"),
			contactSupport: gettext("Contact Support"),
			featureFeedback: gettext("Feature Feedback"),
		},
		applicant: {
			pages: gettext("Pages"),
			programs: gettext("Programs"),
			myApplications: gettext("My Applications"),
		},
		reviewer: { reviewDashboard: gettext("Review Dashboard") },
		recommender: { 
			recommendations: gettext("Recommendations"),
			recommenderDashboard: gettext("Recommender Dashboard"),
		},
		common: {
			myAccount: gettext("My Account"),
			applicant: gettext("Applicant"),
			reviewer: gettext("Reviewer"),
			recommender: gettext("Recommender"),
			administrator: gettext("Administrator"),
			help: gettext("Help"),
			helpCenter: gettext("Help Center"),
			signOut: gettext("Sign Out"),
			contactAdmin: gettext("Questions about a program or information on this site?"),
			contactAdminDesc: gettext("Contact the site administrator"),
			faq: gettext("Need help with using SurveyMonkey Apply?"),
			faqDesc: gettext("Check out the FAQ"),
			contactSupport: gettext("Having technical issues with this site?"),
			contactSupportDesc: gettext("Fill in a support request form"),
			contactAdminSubject: gettext("Questions for"),
			switchRoleTo: gettext("Switch role to..."),
			userMenu: gettext("Common user menu items"),
		},
	},
};
export default STRINGS;
